export default __webpack_public_path__ + "44f116022240763029e8fa9d25f72ef9.svg";